"use client";

import {
  AdjustmentsHorizontalIcon,
  ChevronRightIcon,
} from "@heroicons/react/24/outline";

import { DesktopNavItem } from "@/components/navbar/DesktopNavItem";
import { Button } from "@/components/ui/Button";
import { useAppContext } from "@/context/AppContext";
import type { translations } from "@/i18n/translations";
import type { Language } from "@/i18n/translations";

type NavbarTranslations = (typeof translations)[Language]["navbar"];

type SettingsControlsProps = {
  navbar: NavbarTranslations;
  onCloseMenu?: () => void;
  switchId: string;
  onBugReportOpen: () => void;
  onPreferencesOpen: () => void;
};

export function SettingsControls({
  navbar,
  onCloseMenu,
  onPreferencesOpen,
}: SettingsControlsProps) {
  const { SETTINGS_ITEMS } = useAppContext();

  return (
    <>
      <Button
        className="group settings-row h-auto justify-start gap-x-3 px-1 py-1"
        type="button"
        variant="icon"
        onClick={onPreferencesOpen}
      >
        <span className="settings-icon-wrapper">
          <AdjustmentsHorizontalIcon
            className="settings-icon"
            aria-hidden="true"
          />
        </span>
        <span className="settings-label">{navbar.preferences}</span>
        <ChevronRightIcon className="settings-chevron-shift" />
      </Button>

      {SETTINGS_ITEMS.map((item, idx) => (
        <DesktopNavItem item={item} key={idx} onClose={onCloseMenu} />
      ))}
    </>
  );
}
